import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const imageUploadContainer = style({
  position: 'relative',
  display: 'inline-block',
  maxWidth: '100%'
})

export const imageUploadImage = style({
  maxWidth: '100%',
  height: 'auto'
})

const progressSteps = Array.from({ length: 101 }, (_, progress) => progress)

export const imageUploadProgressBar = style({
  height: '100%',
  width: '100%',
  selectors: Object.fromEntries(
    progressSteps.map((progress) => [
      `&[data-progress="${progress}"]`,
      { width: `${100 - progress}%` }
    ])
  ),
  transition: 'width 0.3s ease',
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,
  backgroundColor: `color-mix(in srgb, ${vars.color.mediumLighter} 80%, transparent)`
})

export const imageUploadProgressText = style({
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: `color-mix(in srgb, ${vars.color.white} 80%, transparent)`,
  backdropFilter: 'blur(10px)',
  padding: 4,
  fontSize: vars.font.smallNormal.size,
  color: vars.color.dark,
  fontWeight: vars.font.smallNormal.weight,
  zIndex: 2
})

export const imageUploadError = style({
  padding: 8,
  position: 'absolute',
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  backgroundColor: vars.color.danger,
  color: vars.color.white,
  borderRadius: 4,
  fontSize: vars.font.smallNormal.size,
  zIndex: 2
})

export const imageUploadRemoveButton = style({
  background: 'none',
  border: `1px solid ${vars.color.white}`,
  borderRadius: 4,
  color: vars.color.white,
  cursor: 'pointer',
  padding: '2px 6px',
  fontSize: vars.font.smallNormal.size,
  whiteSpace: 'nowrap'
})
